export default {
	type: 'checkbox',
	input: true,
	key: 'openWhenEmpty',
	persistent: true,
	label: 'Automatically Open Widget in Application',
	tooltip: 'This will allow users to see all fields opened in the application.',
	weight: 1000
};
